export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14587.9f113596.jpg";